// Copyright © 2023 CATTLEytics Inc.
export enum AnimalReproductionStatus {
  Bred = 'bred',
  Open = 'open',
  Pregnant = 'pregnant',
  Unknown = 'unknown',
}
